import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { JackBaseComponentModule, MaterialModule, PageKind, UiModeType, } from 'jk-service';
import { MtrwcService,  } from '../_service_mtr';
import { MtrwcEditComponent, } from '../_edit_mtr';
import { jkSingleComponent, AdvComModule } from 'jk-advcom';



@Component({
  selector: 'app-mtrki02-detail',
  standalone: true,
  imports: [
    MaterialModule,
    JackBaseComponentModule,
    AdvComModule,
  ],
  templateUrl: './mtrki02-detailPkg.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [],
})
export class Mtrki02DetailComponent extends jkSingleComponent implements OnInit {
  override _programId = 'mtrki02-detail';
  constructor() {
    super();
    this.srv = new MtrwcService();
    this.pageKind = PageKind.detail;
    this.uiMode = UiModeType.dialog;  //dialog 'tab';
    this.srv.programId = this.programId + '-detail'; // ### modi,不要亂改
    this.srv.linkMasterFields = 'WC001=WB001,WC002=WB002';
    this.masterEditPage = MtrwcEditComponent;
    this.gridInitOpt = { programId: this.programId, sortField: 'WC003', sort: 'asc', defaultSort: null, pageKind: this.pageKind };

    //this.constructorInit(); // ###

  }
  override onWindowResize($event?: any) {
    super.onWindowResize($event);
  }
  override async constructorInit() {
    await super.constructorInit();
    this.srv.cdr = this.cdr;
  };


}
